export default __webpack_public_path__ + "static/media/modal02.73bcca9a.png";